import React from 'react';
import { SvgIconProps } from '@mui/material';

export const ClockIcon: React.FC<SvgIconProps> = (props) => (
    <svg
        width="29"
        height="32"
        viewBox="0 0 29 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M11.1966 1.17969H17.7379M14.4673 10.9917V17.533L17.7379 20.8036M27.5499 17.533C27.5499 24.7583 21.6926 30.6156 14.4673 30.6156C7.24193 30.6156 1.38464 24.7583 1.38464 17.533C1.38464 10.3076 7.24193 4.45034 14.4673 4.45034C21.6926 4.45034 27.5499 10.3076 27.5499 17.533Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default ClockIcon;
